import * as S from './dropdown.styles';

export const { Dropdown } = S;
